export default __webpack_public_path__ + "static/media/placeholder_portfolio04-fr-web.f3549b33.png";